<div class="cvds-structures scrollable-component scrollable container-fluid" #contentRevised>
  <div class="row">
    <div [ngClass]="{ 'col-sm-3': vertical, 'col-sm-12': !vertical}">
      <div class="sticky-top">
        <div class="cvds-structures__menu">
          <ul>
            <li *ngFor="let structure of structures; let i = index;" (click)="onStructureChanged(i)">
                <a href="javascript:void(0)">{{structure.structureType.Value}}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div [ngClass]="{ 'col-sm-9': vertical, 'col-sm-12': !vertical}">
      <div class="cvds-structures__content" *ngIf="structure">
        <cv-cvds-structure
          [structure]="structure"
          [index]="structureIndex">
        </cv-cvds-structure>
      </div>
    </div>
  </div>
</div>
